import { request } from '@/utils/request'
const CommonUtilService = {
  state: {},

  mutations: {},

  actions: {
    // 获取省市区域信息
    GetAllArea({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Area/GetAllArea', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 通用对象分类list
    ObjectClassList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/Object_Class/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取字典值
    GetSelectAllJson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectAllJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default CommonUtilService
